export const gray = '#30343F'
export const transparentGray = 'rgba(48,52,63,0.6)'
export const moreTransparentGray = 'rgba(48,52,63,0.8)'
export const leastTransparentGray = 'rgba(48,52,63,0.95)'
export const yellow = '#FDE74C'
